import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
// import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

// text,email,tel,textarea,password,
@Component({
  selector: 'app-date',
  template: `
    <div [formGroup]="form">
      <!-- <input
        [attr.type]="field.type"
        class="form-control"
        [id]="field.name"
        [name]="field.name"
        [formControlName]="field.formControlName"
        [placeholder]="field.placeHolder"
      /> -->
    </div>
    <div [formGroup]="form">
      <!-- <form class="d-flex"> -->
        <div class="mb-3">
          <div class="input-group">
            <input [formControlName]="field.formControlName" class="form-control" [placeholder]="field.placeHolder"
            [name]="field.formControlName" [(ngModel)]="selectedDate" >
            <button class="input-group-text" type="button">
              <i class="feather icon-calendar icon-md text-muted"></i>
            </button>
          </div>
        </div>
      <!-- </form> -->
      <p class="mt-3 text-muted">Selected: {{ selectedDate | json }}</p>
    </div>
  `,
  // styles: [
  //   `
  //     .form-control {
  //       border: 1px solid gray;
  //       height: 1.6rem;
  //       width: 15rem;
  //       font-size: 1rem;
  //       border-radius: 22px;
  //       padding-left: 12px;
  //       padding-right: 12px;
  //     }
  //   `,
  // ],
})
export class DateComponent {
  @Input() field: any = {};
  @Input() form: FormGroup;
  selectedDate: any;
  get isValid() {
    return this.form.controls[this.field.formControlName].valid;
  }
  get isDirty() {
    return this.form.controls[this.field.formControlName].dirty;
  }

  constructor() {}
}
